import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LookupValue } from '../../../models/lookup.model';

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss']
})
export class TableFilterComponent {
  @Input() name: string = '';
  @Input() lookupValues: LookupValue[] = [];
  @Input() selectedValues: number[] = [];
  @Output() selectValue = new EventEmitter<LookupValue>();
}
